import { render } from "./MarketplaceIcon.vue?vue&type=template&id=fe99f8ae"
import script from "./MarketplaceIcon.vue?vue&type=script&lang=js"
export * from "./MarketplaceIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__